import { Application } from '~/types/Application';
import { getStagePayload } from './getStagePayload';

export const hasAtLeastOneDeclinedField = (
  application: Application | undefined,
  fieldKey: string
): boolean => {
  const stagePayload = getStagePayload.wizard(application);
  if (!stagePayload) return false;
  return !!application?.payload?.errorInfo?.errors?.find((errObj) => errObj.key.includes(fieldKey));
};

export const hasAtLeastOneWarningField = (
  application: Application | undefined,
  fieldKey: string
): boolean => {
  const stagePayload = getStagePayload.wizard(application);
  if (!stagePayload) return false;
  return !!application?.payload?.errorInfo?.errors?.find(
    (errObj) => errObj.key.includes(fieldKey) && errObj.type === 'WARN'
  );
};
